// extracted by mini-css-extract-plugin
export default {"nav-link-custom":"NavBarLink_nav-link-custom__+Nxnk","resume-btn":"NavBarLink_resume-btn__au2d2"};